/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { EmberChangeset } from "ember-changeset";
export default class TreatmentHistoryProtocolUtilsProtocolSectionComponent extends Component {
  get allCureIndexes() {
    return Array.from({
      length: 6
    }, (_, index) => index + 2);
  }
}